import { useTranslation as e } from "../i18n/hooks.js";
import { localizeDiagnostics as t } from "./validation/catalog.js";
import { mergeDiagnostics as n } from "./validation/merge-diagnostics.js";
import { runBuiltInValidation as r } from "./validation/run-built-in-validation.js";
import { useEffect as i, useMemo as a, useRef as o, useState as s } from "react";
//#region src/tracking-code-input/use-tracking-code-validation.ts
var c = 300;
function l({ value: l, builtInValidation: d = !0, diagnostics: f, messageOverrides: p, onValidationChange: m }) {
	let h = o(null), g = o(null), _ = o(!1), v = o(m), y = o(null);
	v.current = m;
	let { t: b } = e(), [x, S] = s(() => {
		if (!d) return [];
		let e = r(l);
		return h.current = {
			value: l,
			diagnostics: e.diagnostics
		}, e.diagnostics;
	}), C = (e) => {
		if (h.current?.value === e) return h.current.diagnostics;
		let t = r(e);
		return h.current = {
			value: e,
			diagnostics: t.diagnostics
		}, t.diagnostics;
	};
	i(() => {
		if (!d) {
			S([]), g.current = l, _.current = !0;
			return;
		}
		let e = !_.current, t = g.current !== l;
		if (_.current = !0, e || !t) {
			S(C(l)), g.current = l;
			return;
		}
		let n = window.setTimeout(() => {
			S(C(l)), g.current = l;
		}, c);
		return () => {
			window.clearTimeout(n);
		};
	}, [l, d]);
	let w = a(() => {
		let e = n(x, f ?? [], p);
		return {
			...e,
			diagnostics: t(e.diagnostics, b)
		};
	}, [
		x,
		f,
		p,
		b
	]);
	return i(() => {
		let e = u(w);
		y.current !== e && (y.current = e, v.current?.(w));
	}, [w]), w;
}
function u(e) {
	return JSON.stringify({
		valid: e.valid,
		diagnostics: e.diagnostics
	});
}
//#endregion
export { l as useTrackingCodeValidation };
